import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { BsArrowRight } from 'react-icons/bs'
import blogPosts from './blogs.json'
import './BlogSection.css'

function BlogSection() {
  return (
    <div className="section-container">
      <Container>
        <h2 className="section-title">Latest Technical Insights</h2>
        <Row className="g-4">
          {blogPosts.map((post, index) => (
            <Col key={index} xs={12} md={6} lg={4}>
              <Card className="modern-card blog-card h-100">
                <div className="blog-image-wrapper">
                  <img
                    className="blog-card-image"
                    src={post.image}
                    alt={post.title}
                    loading="lazy"
                    decoding="async"
                    referrerPolicy="no-referrer"
                    onError={e => {
                      e.currentTarget.onerror = null
                      e.currentTarget.src =
                        process.env.PUBLIC_URL + '/assets/images/logo512.jpeg'
                    }}
                  />
                  <div className="blog-date-badge" aria-label={`Published on ${post.date}`}>
                    {post.date}
                  </div>
                </div>
                <Card.Body className="d-flex flex-column pt-3">
                  <Card.Title className="blog-title flex-grow-1">{post.title}</Card.Title>
                  <a
                    href={post.link}
                    className="modern-btn blog-read-btn text-center"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Read more: ${post.title}`}
                  >
                    <span>Read Article</span>
                    <BsArrowRight aria-hidden="true" />
                  </a>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default BlogSection
